<template>
  <header class="header">
    <div class="table-actions-wrap">
      <div class="left-aligned-wrap">
        <woot-sidemenu-icon />
        <back-button
          v-if="showBackButton"
          :button-label="backButtonLabel"
          :back-url="``"
        />
        <h1 class="page-title header-title">
          {{ $t(headerTitle) }}
        </h1>
      </div>
    </div>
  </header>
</template>

<script>
import adminMixin from 'dashboard/mixins/isAdmin';
import BackButton from 'dashboard/components/widgets/BackButton.vue';

export default {
  components: {
    BackButton
  },
  mixins: [adminMixin],
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    backButtonLabel: {
      type: String,
      default: '',
    },
    showBackButton: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  margin: 0;
}
.table-actions-wrap {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: var(--space-small) var(--space-normal) var(--space-small)
    var(--space-normal);
}

.left-aligned-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  min-width: var(--space-mega);

  .header-title {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin: 0 var(--space-small);
  }
}

.right-aligned-wrap {
  display: flex;
}
.header {
  background: var(--white);
}
</style>
